module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq319-9c0d4d5a50046aef1d5864ac8ae037ba.jpg";